import React, { useState, useEffect } from 'react';
import Footer from '../../components/Footer';
import AccountDashboard from './AccountDashboard';
import { useUser } from '../../components/UserProvider';
import { useNavigate } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'; 
import { useInitData } from '@telegram-apps/sdk-react';
import { wallet } from '../../assets';
import './index.css';
import Modal from '../../components/Modal';
import { TonConnectButton, useTonAddress, useTonConnectUI } from '@tonconnect/ui-react';
import WalletActions from './WalletActions';


const truncateHtml = (html, maxLength) => {
    const div = document.createElement('div');
    div.innerHTML = html;
    let truncated = div.innerText;

    if (truncated.length > maxLength) {
        truncated = truncated.substring(0, maxLength) + '...';
    }

    return truncated;
};

const AccountPage = () => {
    const navigate = useNavigate(); 
    const userData = useUser();
    const apiUrl = process.env.REACT_APP_API_URL;
    const [favoriteApps, setFavoriteApps] = useState([]);
    const telegramUserId = localStorage.getItem('telegram_user_id');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const initData = useInitData()
    const [tonConnectUI, setOptions] = useTonConnectUI();

    const userFriendlyAddress = useTonAddress();
    const rawAddress = useTonAddress(false);


    const openModal = () => {
        console.log("Opening modal...");
        setIsModalOpen(true);
    };

    const closeModal = () => {
        console.log("Closing modal...");
        setIsModalOpen(false);
    };
    
    useEffect(() => {
        const fetchFavoriteApps = async () => {
            if (!telegramUserId) return;

            try {
                const response = await fetch(`${apiUrl}apps/favorites/list/?user_id=${telegramUserId}`);
                if (!response.ok) {
                    throw new Error(`Error fetching favorite apps: ${response.status}`);
                }

                const favoritesData = await response.json();
                const favoriteDetailsPromises = favoritesData.map(async (favorite) => {
                    const { app_id, miniapp_id } = favorite;

                    if (app_id) {
                        const appResponse = await fetch(`${apiUrl}apps/list/${app_id}/`);
                        if (appResponse.ok) {
                            const appData = await appResponse.json();
                            return { ...favorite, app: appData };
                        }
                    } else if (miniapp_id) {
                        const miniAppResponse = await fetch(`${apiUrl}miniapps/${miniapp_id}/`);
                        if (miniAppResponse.ok) {
                            const miniAppData = await miniAppResponse.json();
                            return { ...favorite, miniapp: miniAppData };
                        }
                    }

                    return null;
                });

                const favoriteDetails = await Promise.all(favoriteDetailsPromises);
                setFavoriteApps(favoriteDetails.filter((item) => item !== null)); 
            } catch (error) {
                console.error('Error fetching favorite apps:', error);
            }
        };

        fetchFavoriteApps();
    }, [telegramUserId, apiUrl]);

    const handleViewApp = (id) => {
        navigate(`/app/${id}`);
    };

    return (
        <div className="app-list">
            <div className="user-img">
                <div>
                    {initData?.user?.photoUrl && (
                        <img
                            src={initData.user.photoUrl}
                            alt="User"
                            className="user-photo"
                        />
                    )}
                    @{userData?.username || "Loading..."}
                </div>
                <div onClick={openModal}>
                    <img
                        src={wallet}
                        alt="Wallet"
                        className="wallet-icon"
                    />
                </div>
            </div>
    
            <h2>My Telegram Mini Apps</h2>
            {userData?.apps?.length > 0 ? ( 
                <div className="horizontal-scroll">
                    {userData.apps.map((app) => (
                        <div key={app.id} className="app-item">
                            <img
                                src={`${apiUrl}${app.icon}`}
                                alt={`${app.name} icon`}
                                className="app-icon"
                            />
                            <div className="app-details">
                                <h2>{app.name}</h2>
                                <p dangerouslySetInnerHTML={{ __html: truncateHtml(app.description, 50) }} />
                                <p className="rating">
                                    {app.rating ? `${app.rating} ★` : "No rating"}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <p>Loading your apps or no apps available.</p>
            )}
    
            <h2>My Favorite Apps</h2>
            {favoriteApps.length > 0 ? (
                <div className="favorite-apps-container">
                    <div className="favorite-apps-grid">
                        {favoriteApps.map((favorite) => {
                            const app = favorite.app || favorite.miniapp;
                            if (!app) return null;
    
                            return (
                                <div key={app.id} className="app-item">
                                    <img
                                        src={`${apiUrl}${app.icon}`}
                                        alt={`${app.name} icon`}
                                        className="app-icon"
                                    />
                                    <div className="app-details">
                                        <h2>{app.name}</h2>
                                        <p dangerouslySetInnerHTML={{ __html: truncateHtml(app.description, 50) }} />
                                        <p className="rating">
                                            {app.rating ? `${app.rating} ★` : "No rating"}
                                        </p>
                                    </div>
                                    <div className="app-action">
                                        <FontAwesomeIcon
                                            icon={faArrowRight}
                                            onClick={() => handleViewApp(app.id)}
                                            className="view-app-icon"
                                        />
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            ) : (
                <p>You have no favorite apps.</p>
            )}
    
            <AccountDashboard />
    
            <Modal isOpen={isModalOpen} onClose={closeModal}>
                <div className="wallet-actions">
                <WalletActions closeModal={closeModal} />
                </div>
            </Modal>
    
            <Footer />
        </div>
    );
    
};

export default AccountPage;
